/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_No_MatchesInputs */

const cs_settings_teams_no_matches = /** @type {(inputs: Settings_Teams_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikdo nevyhovuje.`)
};

const en_settings_teams_no_matches = /** @type {(inputs: Settings_Teams_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching people.`)
};

/**
* | output |
* | --- |
* | "No matching people." |
*
* @param {Settings_Teams_No_MatchesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_no_matches = /** @type {((inputs?: Settings_Teams_No_MatchesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_No_MatchesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_no_matches(inputs)
	return cs_settings_teams_no_matches(inputs)
});